var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelay = function SvgDelay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M35.965 21.985V10.5a1.5 1.5 0 0 0-1.5-1.5H28.49v5.486a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V9H10.5A1.5 1.5 0 0 0 9 10.5v18.017a1.5 1.5 0 0 0 1.5 1.5h10.592c.714-5.103 5.097-9.031 10.398-9.031 1.6 0 3.117.358 4.475.999zm2.92 2.048a10.468 10.468 0 0 1 3.105 7.453c0 5.799-4.701 10.5-10.5 10.5-5.28 0-9.648-3.895-10.39-8.969H10.5a4.5 4.5 0 0 1-4.5-4.5V10.5A4.5 4.5 0 0 1 10.5 6h23.965a4.5 4.5 0 0 1 4.5 4.5v13.533h-.08zM25.49 9h-6v2.986h6V9zm6 29.986a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15zm3.013-9.014a1.5 1.5 0 1 1 0 3H30.49a.5.5 0 0 1-.5-.5v-5.486a1.5 1.5 0 0 1 3 0v2.986h1.513zM13.49 26.986a1.5 1.5 0 1 1 0-3h3a1.5 1.5 0 0 1 0 3h-3z"
  })));
};
export default SvgDelay;